<template>
	<div class="row">
		<div class="mr-auto ml-auto  col-lg-10">
			<!-- <button class="btn btn-secondary">
        <i class="fa fa-file-excel-o" aria-hidden="true"/>
        {{ 'Download' | translate }}
      </button> -->
			<div class="table-responsive">
				<table class="table">
					<tr>
						<th>ID</th>
						<th>{{ 'Payment Amount' | translate }}</th>
						<th>{{ 'Person' | translate }}</th>
						<th>{{ 'Group' | translate }}</th>
						<th>{{ 'Parents' | translate }}</th>
						<th>{{ 'Homework' | translate }}</th>
						<th v-if="isStatisticView">{{ 'Statistics' | translate }}</th>
						<th>{{ 'Actions' | translate }}</th>
					</tr>
					<tr v-for="profile in listProfiles" :key="profile.id">
						<td>{{ profile.id }}</td>
						<td>
							{{ $t('New') }}
							<!-- profile.invoice !== null ? profile.invoice?.amount : -->


							<!-- {{ profile.invoice && profile.currency | toSymbol }} -->
						</td>
						<td>
							<router-link :to="{ name: 'Dashboard Profile', params: { id: profile.id } }">
								{{ profile.last_name }} {{ profile.first_name }}
							</router-link>
							<router-link :to="{
							name: 'Dashboard Student Main',
							query: { read_only: profile.id, from: 'Dashboard List' },
						}">{{ 'To cabinet' | translate }}</router-link>
						</td>
						<td>
							<router-link :to="{
							name: 'Dashboard Group Profile',
							params: { id: profile.group.id },
						}">
								{{ profile.group.name }}
							</router-link>
						</td>
						<td>
							<router-link v-if="profile.parent" :to="{
							name: 'Dashboard Profile',
							params: { id: profile.parent.id },
						}">
								{{ profile.parent.last_name }} {{ profile.parent.first_name }}
							</router-link>
						</td>
						<td @click="
							setProfileName(`${profile.first_name} ${profile.last_name}`)
							">
							<router-link :to="{ name: 'Profile Homework', params: { id: profile.id } }">{{ 'Assign' | translate
								}}</router-link>
						</td>
						<td v-if="isStatisticView">
							<div>
								{{ 'Total played games' | translate }}:
								{{ profile.statistic.played_games_total }}
							</div>
							<div>
								{{ 'Left' | translate }}:
								{{ profile.statistic.homeworks_left }}
							</div>
						</td>
						<td>
							<a class="outline" v-if="notParent" href="#" @click.prevent="openModal(profile.id, 'lessons')">
								{{ 'Lessons' | translate }}
							</a>
							<a class="outline" v-if="notParent" href="#" @click.prevent="showModalIndigoDollars = profile.id">
								{{ 'Indigo-dollars' | translate }}
							</a>
							<!-- <a class="outline" v-if="notParent && !profile.date_deactivated" href="#"
								@click.prevent="showModalDisableStudent = profile.id">
								{{ 'disableStudent.btn' | translate }}
							</a> -->
							<a href="#"
								@click.prevent="openLockModal({ id: profile.id, price: profile.price, name: profile.full_name })"
								class="text-red outline outline-red">{{ 'Block'
							| translate }}</a>
						</td>
					</tr>
				</table>
			</div>
			<ModalIndigoDollaras :id="showModalIndigoDollars" :show="!!showModalIndigoDollars"
				@close="showModalIndigoDollars = false" />

			<ModalDisableStudent :id="showModalDisableStudent" :show="!!showModalDisableStudent"
				@close="showModalDisableStudent = false" @onSuccess="refetchList" />

			<ModalDeleteStudent :show="isBlockModalOpen" @close="isBlockModalOpen = null" @deleteUser="deleteUser"
				@changePrice="changePrice" :choosedLockUser="choosedLockUser" />
		</div>
	</div>
</template>

<script>
import { toSymbol } from '@/helpers/filters'
import ModalIndigoDollaras from '../Modal/IndigoDollars'
import ModalDisableStudent from '../Modal/DisableStudent'
import ModalDeleteStudent from '../Modal/DeleteStudent'

export default {
	components: {
		ModalIndigoDollaras,
		ModalDisableStudent,
		ModalDeleteStudent
	},
	name: 'student',
	computed: {
		listProfiles() {
			return this.$store.state.profiles
		},
		isStatisticView() {
			return this.$route.query.statistics
		},
	},
	data() {
		return {
			showModalIndigoDollars: false,
			showModalDisableStudent: false,
			notParent: this.$store.state.myProfile.role !== 'parent',

			isBlockModalOpen: false,
			choosedLockUser: null,
		}
	},
	filters: {
		toSymbol,
	},
	methods: {
		refetchList() {
			this.$emit('refetchList')
		},
		openIndigoDollarsModal(id) { },

		openModal(id, type) {
			if (typeof id === 'number') {
				let profileArr = []
				profileArr.push(id)
				this.$store.commit('changeModalId', profileArr)
			} else {
				this.$store.commit('changeModalId', id)
			}
			this.$store.commit('changeModalType', type)
			this.$emit('openModal')
		},

		setProfileName(name) {
			this.$store.state.homeworkProfileName = name
		},

		openLockModal({ id, price, name }) {
			this.choosedLockUser = { id, price: parseInt(price), oldPrice: parseInt(price), name, isPriceChanged: false, isUserBlocked: false }
			this.isBlockModalOpen = true
		},

		changePrice() {
			this.axios({
				method: 'patch',
				url: `users/user/${this.choosedLockUser.id}`,
				data: {
					price: Number(this.choosedLockUser.price),
				},
			})
				.then(response => {
					this.$toast(this.$t('Changes saved'), {
						className: ['btn-success', 'notif'],
						duration: 3000,
					})

					this.choosedLockUser.isPriceChanged = true
				})
				.catch(error => {
					console.error(error)
				})
		},

		deleteUser() {
			let delUrl = `users/user/${this.choosedLockUser.id}`

			this.axios({
				method: 'delete',
				url: delUrl,
			}).then(response => {
				this.choosedLockUser.isUserBlocked = true

				this.refetchList()
			})
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (max-width: 576px) {
	.offset-lg-1>.btn {
		width: 100%;
		margin-bottom: 10px;
	}
}
</style>
